import React from "react";
import { Box } from "@chakra-ui/react";

export const ClassIcon = (props) => {
  return (
    <Box {...props}>
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 96 96"
        version="1.1"
        fill="rgb(25.882353%,27.843137%,43.921569%)"
        fillOpacity={1}
      >
        <g id="surface26400668">
          <path d="M 15 21 L 15 69 L 9 69 L 9 75 L 87 75 L 87 69 L 81 69 L 81 21 Z M 21 27 L 75 27 L 75 69 L 21 69 Z M 63.84375 36.84375 L 51 49.6875 L 41.15625 39.84375 L 39 37.78125 L 36.84375 39.84375 L 27.84375 48.84375 L 32.15625 53.15625 L 39 46.3125 L 48.84375 56.15625 L 51 58.21875 L 53.15625 56.15625 L 68.15625 41.15625 Z M 60 60 L 57 63 L 60 66 L 72 66 L 72 60 Z M 60 60 " />
        </g>
      </svg>
    </Box>
  );
};
